import { Checkbox, Radio } from 'antd';
import AbsenceTypesHeader from 'components/common/tables_header/absence_types_header';
import TakingLeaveHeader from 'components/common/tables_header/taking_leave';
import { CustomInput } from 'components/custom';
import ColorDropdown from 'components/dropdown/ColorDropdown';
import AbsenceTypesDes from 'components/tables/absenc_types_des';
import { FormikProps } from 'formik';
import useMember from 'hooks/useMember';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { monthName } from 'utils';
import { validateMinus } from 'utils/common_function';

type AbsenceTypesTabProps = {
  addData?: (data) => void;
  data: any;
  errorName?: any;
  formik?: FormikProps<any>;
  isDetail?: boolean;
};
let days = [];
for (let i = 1; i <= 31; i++) {
  let item = {
    value: i,
    label: i,
  };
  days.push(item);
}

const AbsenceTypesTab = ({
  formik,
  isDetail = false,
}: AbsenceTypesTabProps) => {
  const { getAbsenceTypeById } = useMember();
  const location = useLocation();
  const [checkFlag, setCheckFlag] = useState(false);

  const onChangeTakingLeave = (month: number, value: any, field: string) => {
    const formatData = formik.values?.accruing_conditions.map(
      (item: { month: number; reset_counter: any }) => {
        if (month === item?.month) {
          switch (field) {
            case 'day':
              return {
                ...item,
                day: parseInt(value),
              };
            case 'balance':
              return {
                ...item,
                balance: value,
              };
            case 'reset_counter':
              return {
                ...item,
                reset_counter: !item.reset_counter,
              };
            default:
              return {
                ...item,
              };
          }
        } else {
          return {
            ...item,
          };
        }
      },
    );
    formik.setFieldValue('accruing_conditions', formatData);
  };

  useEffect(() => {
    const parametValue = location.state?.item?.id;
    if (parametValue) {
      getAbsenceTypeById(parametValue).then((res) => {
        if (res) {
          if (
            res?.french_description?.length > 0 ||
            res?.french_long_description?.length > 0 ||
            res?.french_comment?.length > 0
          ) {
            setCheckFlag(true);
          }
          formik?.setValues(res);
        }
      });
    }
  }, []);

  const renderOptions = (item: number) => {
    const options = [];
    for (let i = 1; i <= item; i++) {
      options.push(
        <option key={i} value={i}>
          {i}
        </option>,
      );
    }
    return options;
  };
  return (
    <>
      <div style={{ marginTop: '50px', paddingBottom: '100px' }}>
        <section className={'function_container'}>
          <div
            style={{ background: 'white', padding: '10px 0px 10px 0px' }}
            className={'function_wrapper'}
          >
            <div style={{ padding: 20 }}>
              <div
                style={{
                  display: 'flex',
                  gap: 20,
                  marginTop: 20,
                  position: 'relative',
                }}
              >
                <div
                  style={{ width: '25%' }}
                  className="is-relative color-wrapper"
                >
                  <div
                    style={{
                      width: '100%',
                      height: 50,
                      border: isDetail
                        ? 'none'
                        : formik?.errors?.calendar_color
                        ? '1px solid red'
                        : `0.5px solid  #407FDD`,
                      borderRadius: '6px',
                      padding: '8px 16px',
                      background: isDetail ? '#f5f5f5' : '',
                      fontSize: 12,
                    }}
                  >
                    <div
                      style={{
                        color: '#898989',
                        fontSize: '10px',
                        fontWeight: 400,
                        lineHeight: '16px',
                      }}
                    >
                      {' '}
                      Calendar colour{' '}
                      <span style={{ color: '#E02C2C' }}>*</span>
                    </div>
                    {isDetail
                      ? formik?.values.calendar_color
                      : formik?.values?.calendar_color}
                  </div>
                  {formik?.errors?.calendar_color && (
                    <div
                      style={{
                        fontSize: 10,
                        color: '#E02C2C',
                        fontWeight: 500,
                        marginTop: 2,
                      }}
                    >
                      {formik?.errors?.calendar_color.toString()}
                    </div>
                  )}
                  {!isDetail && (
                    <div className="color-inner">
                      <ColorDropdown
                        onColorSelect={(c) => {
                          formik?.setFieldValue('calendar_color', c);
                        }}
                      />
                    </div>
                  )}
                </div>
                <div
                  style={{ width: '25%' }}
                  className="is-relative color-wrapper"
                >
                  <div
                    style={{
                      width: '100%',
                      height: 50,
                      border: isDetail
                        ? 'none'
                        : formik?.errors?.font_color
                        ? '1px solid red'
                        : `0.5px solid  #407FDD`,
                      borderRadius: '6px',
                      padding: '8px 16px',
                      background: isDetail ? '#f5f5f5' : '',
                      fontSize: 12,
                    }}
                  >
                    <div
                      style={{
                        color: '#898989',
                        fontSize: '10px',
                        fontWeight: 400,
                        lineHeight: '16px',
                      }}
                    >
                      {' '}
                      Code font colour{' '}
                      <span style={{ color: '#E02C2C' }}>*</span>
                    </div>{' '}
                    {formik?.values.font_color
                      ? formik?.values.font_color
                      : formik?.values?.font_color}
                  </div>
                  {formik?.errors?.font_color && (
                    <div
                      style={{
                        fontSize: 10,
                        color: '#E02C2C',
                        fontWeight: 500,
                        marginTop: 2,
                      }}
                    >
                      {formik?.errors?.font_color.toString()}
                    </div>
                  )}
                  {!isDetail && (
                    <div className="color-inner">
                      <ColorDropdown
                        onColorSelect={(c) => {
                          formik?.setFieldValue('font_color', c);
                        }}
                      />
                    </div>
                  )}
                </div>
                <div style={{ width: '25%' }}>
                  <CustomInput
                    required
                    height="50px"
                    fontSize={12}
                    maxLength={2}
                    background={isDetail ? '#f5f5f5' : ''}
                    disabled={isDetail}
                    value={formik?.values?.calendar_code}
                    name="calendar_code"
                    errors={formik?.errors}
                    onChange={formik?.handleChange}
                    width="100%"
                    title="Calendar code"
                  />
                </div>
                <div style={{ width: '25%' }}>
                  <CustomInput
                    required
                    maxLength={30}
                    height="50px"
                    fontSize={12}
                    background={isDetail ? '#f5f5f5' : ''}
                    disabled={isDetail}
                    value={formik?.values?.name}
                    name="name"
                    errors={formik?.errors}
                    onChange={formik?.handleChange}
                    width="100%"
                    title="Name"
                  />
                </div>
              </div>
            </div>
            <div
              style={{
                fontWeight: '500',
                fontSize: 20,
                marginLeft: 20,
                marginBottom: 20,
                color: '#000000',
              }}
            >
              Descriptions
            </div>
            <div>
              <AbsenceTypesHeader />
              <AbsenceTypesDes
                formik={formik}
                setCheckFlag={setCheckFlag}
                checkFlag={checkFlag}
                isDetail={isDetail}
              />
            </div>
          </div>
        </section>
        <section style={{ marginTop: 50 }} className={'function_container'}>
          <div
            style={{ background: 'white', padding: '10px 0px 10px 0px' }}
            className={'function_wrapper'}
          >
            <div style={{ margin: '15px 15px 15px 25px' }}>
              <div style={{ fontWeight: 500, fontSize: 20, color: '#000000' }}>
                Conditions for accruing and taking leave
              </div>
              <Radio.Group
                defaultValue={formik?.values?.accruing_type}
                onChange={(e) => {
                  formik?.setFieldValue('accruing_type', e.target.value);
                }}
                value={formik?.values?.accruing_type}
                style={{ marginTop: '30px' }}
                disabled={isDetail}
              >
                <Radio className="add_user_first_step_text" value={'manage'}>
                  <div
                    style={{
                      color: isDetail ? 'rgba(0, 0, 0, 0.25)' : '#000000',
                    }}
                  >
                    Manage rights counter
                  </div>
                </Radio>
                <Radio className="add_user_first_step_text" value={'free'}>
                  <div
                    style={{
                      color: isDetail ? 'rgba(0, 0, 0, 0.25)' : '#000000',
                    }}
                  >
                    Free right counter
                  </div>
                </Radio>
              </Radio.Group>
            </div>
            {formik?.values?.accruing_type === 'manage' ? (
              <div>
                <TakingLeaveHeader />
                <div style={{ marginTop: '10px' }}>
                  {monthName?.map((item, index) => (
                    <div
                      style={{
                        display: 'flex',
                        gap: '10px',
                        height: '45px',
                        alignItems: 'center',
                      }}
                      key={index}
                    >
                      <div
                        style={{
                          width: '25%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '12px',
                          color: '#000000',
                        }}
                      >
                        {item.label}
                      </div>
                      <div
                        style={{
                          width: '25%',
                        }}
                      >
                        <select
                          disabled={isDetail}
                          style={{
                            padding: '0px',
                            width: '100%',
                            height: 30,
                            opacity: 1,
                            border: '0.5px solid #407FDD',
                            background: isDetail ? '#f5f5f5' : '',
                          }}
                          className="common_custom_input_search"
                          onChange={(e) =>
                            onChangeTakingLeave(
                              item.value,
                              e.target.value,
                              'day',
                            )
                          }
                          value={
                            formik?.values?.accruing_conditions.find(
                              (i) => i.month === item.value,
                            )?.day
                          }
                        >
                          {renderOptions(item.day)}
                        </select>
                      </div>
                      <input
                        disabled={isDetail}
                        defaultValue={
                          isDetail
                            ? formik?.values?.accruing_conditions.find(
                                (i) => i.month === item.value,
                              )?.balance
                            : '0.0'
                        }
                        onKeyDown={validateMinus}
                        min={0}
                        max={99999}
                        onPaste={(e) => {
                          e.preventDefault();
                        }}
                        type="number"
                        onChange={(e) =>
                          onChangeTakingLeave(
                            item.value,
                            e.target.value,
                            'balance',
                          )
                        }
                        style={{
                          width: '25%',
                          height: 30,
                          background: isDetail ? '#f5f5f5' : '',
                        }}
                        className="common_custom_input_search"
                      />
                      <div
                        style={{
                          width: '25%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                        className="checkbox_input"
                      >
                        <Checkbox
                          style={{
                            opacity: 1,
                            // border: '1px solid #9B9B9B',
                            // height: 16,
                            // width: 16
                          }}
                          onChange={(e) => {
                            onChangeTakingLeave(
                              item.value,
                              e.target.value,
                              'reset_counter',
                            );
                          }}
                          checked={
                            formik?.values?.accruing_conditions.find(
                              (i: { month: number }) => i.month === item.value,
                            )?.reset_counter
                          }
                          disabled={isDetail}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div>
                <div style={{ margin: 23 }}>
                  <CustomInput
                    required
                    background={isDetail ? '#f5f5f5' : ''}
                    onKeyDown={(e) => {
                      validateMinus(e);
                    }}
                    name="balance"
                    disabled={isDetail}
                    onChange={(e) => {
                      const value = e.target.value;
                      const split = e.target.value.split('');

                      const findIndex = split.findIndex((item) => item === '.');

                      if (findIndex > 0) {
                        const isValid = value.substr(
                          findIndex + 1,
                          value.length - findIndex,
                        );

                        if (+isValid % 5 !== 0)
                          formik.setFieldError(
                            'balance',
                            'The decimal part must be 0 or 5',
                          );
                        else {
                          //doing success here
                          formik.setFieldError('balance', undefined);
                        }
                      }

                      formik.handleChange(e);
                    }}
                    value={
                      isDetail
                        ? formik?.values?.balance
                        : formik?.values?.balance === -1
                        ? '0.0'
                        : formik?.values?.balance
                    }
                    defaultValue={'0.0'}
                    title="Accrued entitlement"
                    errors={
                      formik.values.accruing_type === 'free' && formik.errors
                    }
                    // inputMode="numeric"
                    min={0}
                    maxLength={
                      formik?.values?.balance?.toString()?.includes('.') ? 4 : 3
                    }
                    max={99999}
                    onPaste={(e) => {
                      e.preventDefault();
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </section>
      </div>
    </>
  );
};

export default AbsenceTypesTab;
